import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const AuthCallback = () => {
  const { exchangeSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Try hash from react-router location first, then fall back to window.location
        const hash = location.hash || window.location.hash || '';
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          const msg = `No session_id found. URL: ${window.location.href}`;
          console.error(msg);
          setError(msg);
          toast.error('Sign in failed: no session token received');
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        const user = await exchangeSession(sessionId);
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        const msg = error?.response?.data?.detail || error?.message || 'Unknown error';
        console.error('Auth callback error:', msg, error);
        setError(`Exchange failed: ${msg}`);
        toast.error(`Sign in failed: ${msg}`);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    processSession();
  }, [exchangeSession, navigate, location.hash]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="w-12 h-12 text-primary animate-spin mx-auto" />
        <p className="text-foreground-muted">
          {error ? 'Sign in failed, redirecting...' : 'Completing sign in...'}
        </p>
        {error && (
          <p className="text-destructive text-sm max-w-md mx-auto font-mono">{error}</p>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
